type CacheEntry = {
  body: any
  expiresAt: number
  headers: Record<string, string>
}

const cache: Record<string, CacheEntry> = {}

const extractHeaders = (headers: Headers): Record<string, string> => {
  const result: Record<string, string> = {}
  headers.forEach((value, key) => {
    result[key] = value
  })
  return result
}

const parseMaxAge = (cacheControl: string | null): number => {
  if (!cacheControl) return 0

  const match = cacheControl.match(/max-age=(\d+)/)
  return match ? parseInt(match[1], 10) : 0
}

export const cachedFetch = async (url: string, options?: RequestInit): Promise<Response> => {
  const now = Date.now()
  const cached = cache[url]

  if (cached) {
    if (now < cached.expiresAt) {
      return new Response(JSON.stringify(cached.body), {
        headers: {
          ...cached.headers,
          'X-Cache': 'HIT',
        },
        status: 200,
      })
    } else {
      delete cache[url] // lazy cleanup
    }
  }

  const res = await fetch(url, options)

  if (!res.ok) {
    throw new Error(`Fetch failed: ${res.status} ${res.statusText}`)
  }

  const cacheControl = res.headers.get('Cache-Control')
  const maxAge = parseMaxAge(cacheControl)

  const body = await res.json()
  const headers = extractHeaders(res.headers)

  cache[url] = {
    body,
    expiresAt: now + maxAge * 1000,
    headers,
  }

  return new Response(JSON.stringify(body), {
    headers: {
      ...headers,
      'X-Cache': 'MISS',
    },
    status: res.status,
  })
}

// Periodic cleanup of expired cache entriesq
setInterval(() => {
  const now = Date.now()
  for (const [url, entry] of Object.entries(cache)) {
    if (now >= entry.expiresAt) {
      delete cache[url]
    }
  }
}, 60_000)
